// postMessage helpers for the embed iframe ↔ host bridge.
// Protocol (mirrors the WS3 plan):
//   iframe → parent: { type: "axify:ready" }    on mount
//   iframe → parent: { type: "axify:close" }    when guest closes the widget
//   parent → iframe: { type: "axify:config", mode?: "voice" | "text" }

const READY = "axify:ready";
const CLOSE = "axify:close";
const CONFIG = "axify:config";
const TEARDOWN = "axify:teardown";

function isEmbedded() {
  return typeof window !== "undefined" && window.parent && window.parent !== window;
}

export function postReady() {
  if (!isEmbedded()) return;
  try {
    window.parent.postMessage({ type: READY }, "*");
  } catch (_) {
    // Cross-origin restrictions can throw on older browsers; safe to ignore.
  }
}

export function postClose() {
  if (!isEmbedded()) return;
  try {
    window.parent.postMessage({ type: CLOSE }, "*");
  } catch (_) {
    // Same as above.
  }
}

// Subscribe to axify:config messages from the host. Returns an unsubscribe fn.
export function onConfig(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => {
    const data = event && event.data;
    if (!data || typeof data !== "object") return;
    if (data.type !== CONFIG) return;
    handler(data);
  };
  window.addEventListener("message", listener);
  return () => window.removeEventListener("message", listener);
}

// Subscribe to axify:teardown messages from the host (sent when the host
// calls AxifyWidget.close() programmatically). Returns an unsubscribe fn.
export function onTeardown(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => {
    const data = event && event.data;
    if (!data || typeof data !== "object") return;
    if (data.type !== TEARDOWN) return;
    handler(data);
  };
  window.addEventListener("message", listener);
  return () => window.removeEventListener("message", listener);
}
